/**
 * @author mrdoob / http://mrdoob.com/
 */

import {
  RGBAFormat,
  RGBFormat,
  ImageLoader,
  Texture,
	Loader,
	LinearMipMapLinearFilter,
	LinearFilter,
} from 'three';

function TextureLoader( manager ) {

	Loader.call( this, manager );

}

const createTexturePlaceholder = (color = '#ffffff') => {
  const canvas = document.createElement('canvas');
  canvas.width = 4;
  canvas.height = 4;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = `${color}`;
  ctx.fillRect(0, 0, 4, 4);

  return canvas;
};

TextureLoader.prototype = Object.assign( Object.create( Loader.prototype ), {

	constructor: TextureLoader,

	load: function ( url, onLoad, onProgress, onError, placeholderColor ) {

    var texture = new Texture(createTexturePlaceholder(placeholderColor));
    texture.needsUpdate = true;

		var loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		loader.load( url, function ( image ) {

			texture.image = image;

			// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
			var isJPEG = url.search( /\.jpe?g($|\?)/i ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;

			texture.format = isJPEG ? RGBFormat : RGBAFormat;
			texture.needsUpdate = true;
			texture.minFilter = LinearMipMapLinearFilter
			texture.magFilter = LinearFilter;
			texture.anisotropy = 16;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	}

} );


export { TextureLoader };
